










import Vue from "vue";
import { Component, Watch, Emit } from "vue-property-decorator";
import { translate } from "../../services/translation/translation";
import './winners-carousel.less';
import winnerCarousel from "@/components/winner-carousel/winner-carousel.vue";
import {getWinnerItems} from "@/services/getWinnerData/getWinnerData";

@Component({
  components: {
    winnerCarousel
  }
})
export default class winnersCarouselBlock extends Vue {

  private winnerItems :any[]= [];
  private winnerLocalItems :any[] = [];

  private lifeDetailsUrl :string = '';
  mounted() {
    this.winnerItems = getWinnerItems();
    $.each(this.winnerItems, (index, winnerItemsArray)=>{
      $.each(winnerItemsArray, (index, item)=>{
        if(item.life_challenge_total_winner == 1){
          this.winnerLocalItems.unshift(item);
        }else if(item.life_challenge_winner == 1){
          this.winnerLocalItems.push(item);
        }
      })
    })
  }


  @Watch("selectCategory", {immediate: true, deep: true})
  onSelectCategory(id) {
    if (id !== undefined) {
    }

  }

  trans(key) {
    return translate(key);
  }
}
